// Remove all duplicates in the array, returning only unique values
export const distinctArray = <T extends unknown>(array1: T[]): T[] => {
  return array1.filter((value, index, self): boolean => {
    return self.indexOf(value) === index
  })
}
